<template>
   <aside id="default-sidebar"
      class="fixed left-0 z-20 bg-white  mx-auto h-[100vh] container max-w-[200px] transition-transform -translate-x-full sm:translate-x-0 overflow-auto"
      aria-label="Sidebar">
      <div class="h-full px-1  py-4 overflow-y-scroll border border-r-1 flex flex-col justify-start items-start">
         <ul class="space-y-3 w-full">
            <li class="flex items-center flex-col">


               <div class="flex w-full py-2 rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.path as string) == '/' ? 'text-white bg-primary-900 ' : 'text-primary']">
                  <NuxtLink to="/"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <svg data-v-9bfe6e62="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 24"
                        class="fill-current h-6 w-6 flex-shrink-0">
                        <path data-v-9bfe6e62=""
                           d="M2.54 2H5.92C7.33 2 8.46 3.15 8.46 4.561V7.97C8.46 9.39 7.33 10.53 5.92 10.53H2.54C1.14 10.53 0 9.39 0 7.97V4.561C0 3.15 1.14 2 2.54 2ZM2.54 13.4697H5.92C7.33 13.4697 8.46 14.6107 8.46 16.0307V19.4397C8.46 20.8497 7.33 21.9997 5.92 21.9997H2.54C1.14 21.9997 0 20.8497 0 19.4397V16.0307C0 14.6107 1.14 13.4697 2.54 13.4697ZM17.4601 2H14.0801C12.6701 2 11.5401 3.15 11.5401 4.561V7.97C11.5401 9.39 12.6701 10.53 14.0801 10.53H17.4601C18.8601 10.53 20.0001 9.39 20.0001 7.97V4.561C20.0001 3.15 18.8601 2 17.4601 2ZM14.0801 13.4697H17.4601C18.8601 13.4697 20.0001 14.6107 20.0001 16.0307V19.4397C20.0001 20.8497 18.8601 21.9997 17.4601 21.9997H14.0801C12.6701 21.9997 11.5401 20.8497 11.5401 19.4397V16.0307C11.5401 14.6107 12.6701 13.4697 14.0801 13.4697Z">
                        </path>
                     </svg>
                     <span class="uppercase font-semibold">{{ $t('dashboard') }}</span>
                  </NuxtLink>
               </div>


            </li>

            <li v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN" class="flex items-center flex-col">
               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('products') ? 'text-white bg-primary transition-all ' : 'text-primary']">
                  <NuxtLink to="/products"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6 flex-shrink-0">
                        <path stroke-linecap="round" stroke-linejoin="round"
                           d="M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9" />
                     </svg>

                     <span class="uppercase font-semibold">{{ $t('products') }}</span>
                  </NuxtLink>
               </div>


            </li>
            <li v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN" class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('agencies') ? 'text-white bg-primary transition-all ' : 'text-primary ']">
                  <NuxtLink to="/agencies"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6 flex-shrink-0">
                        <path stroke-linecap="round" stroke-linejoin="round"
                           d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" />
                     </svg>

                     <span class="uppercase font-semibold">{{ $t('agencies') }}</span>
                  </NuxtLink>
               </div>


            </li>
            <li v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.AGENCY_MANAGER"
               class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('agencies') ? 'text-white bg-primary transition-all ' : 'text-primary ']">
                  <NuxtLink
                     :to="{ path: '/agencies/home', query: { agency_id: UserProfile()?.agencyId, country_id: UserProfile()?.countryId } }"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6 flex-shrink-0">
                        <path stroke-linecap="round" stroke-linejoin="round"
                           d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" />
                     </svg>

                     <span class="uppercase font-semibold">{{ $t('manageAgencies') }}</span>
                  </NuxtLink>
               </div>


            </li>
            <li v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN" class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('users') ? 'text-white bg-primary transition-all ' : 'text-primary']">
                  <NuxtLink to="/users"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6 flex-shrink-0">
                        <path stroke-linecap="round" stroke-linejoin="round"
                           d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
                     </svg>

                     <span class="uppercase font-semibold">{{ $t('delegates') }}</span>
                  </NuxtLink>
               </div>


            </li>
            <li v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN" class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('countries') ? 'text-white bg-primary transition-all ' : 'text-primary']">
                  <NuxtLink to="/countries"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6 flex-shrink-0">
                        <path stroke-linecap="round" stroke-linejoin="round"
                           d="M20.893 13.393l-1.135-1.135a2.252 2.252 0 01-.421-.585l-1.08-2.16a.414.414 0 00-.663-.107.827.827 0 01-.812.21l-1.273-.363a.89.89 0 00-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 01-1.81 1.025 1.055 1.055 0 01-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 01-1.383-2.46l.007-.042a2.25 2.25 0 01.29-.787l.09-.15a2.25 2.25 0 012.37-1.048l1.178.236a1.125 1.125 0 001.302-.795l.208-.73a1.125 1.125 0 00-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 01-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 01-1.458-1.137l1.411-2.353a2.25 2.25 0 00.286-.76m11.928 9.869A9 9 0 008.965 3.525m11.928 9.868A9 9 0 118.965 3.525" />
                     </svg>

                     <span class="uppercase font-semibold">{{ $t('zones') }}</span>
                  </NuxtLink>
               </div>


            </li>
            <li class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('annuaire') ? 'text-white bg-primary transition-all ' : 'text-primary']">
                  <NuxtLink to="/annuaire/health-centers"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                        class="size-6 flex-shrink-0">
                        <path fill-rule="evenodd"
                           d="M7.502 6h7.128A3.375 3.375 0 0 1 18 9.375v9.375a3 3 0 0 0 3-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 0 0-.673-.05A3 3 0 0 0 15 1.5h-1.5a3 3 0 0 0-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6ZM13.5 3A1.5 1.5 0 0 0 12 4.5h4.5A1.5 1.5 0 0 0 15 3h-1.5Z"
                           clip-rule="evenodd" />
                        <path fill-rule="evenodd"
                           d="M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V9.375ZM6 12a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V12Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM6 15a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V15Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM6 18a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V18Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75Z"
                           clip-rule="evenodd" />
                     </svg>


                     <span class="uppercase font-semibold">{{ $t('addressBook') }}</span>
                  </NuxtLink>
               </div>


            </li>

            <li v-if="((RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN || RoleIndex(UserProfile()?.roles) === RoleCategory.AGENCY_MANAGER) && $config.public.moduleNotification)"
               class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('notification') ? 'text-white bg-primary transition-all ' : 'text-primary']">
                  <NuxtLink to="/notification"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <AtomNotificationIcon class="flex-shrink-0" />
                     <span class="uppercase font-semibold">{{ $t('notificationCenter') }}</span>
                  </NuxtLink>
               </div>


            </li>

            <li v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN" class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('stat-center') ? 'text-white bg-primary transition-all ' : 'text-primary']">
                  <NuxtLink to="/stat-center"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <AtomStatIcon class="flex-shrink-0" />
                     <span class="uppercase font-semibold">{{ $t('statCenter') }}</span>
                  </NuxtLink>
               </div>


            </li>
            <li class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('admin-report') ? 'text-white bg-primary transition-all ' : 'text-primary']">
                  <NuxtLink to="/admin-report"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">

                     <AtomReportIcon class="flex-shrink-0" />
                     <span class="uppercase font-semibold">{{ $t('adminReport') }}</span>
                     <div v-if="unreadReport > 0" class="ml-auto px-2 bg-red-500 text-white rounded">{{ unreadReport }}
                     </div>
                  </NuxtLink>
               </div>


            </li>

            <li v-if="(RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN && $config.public.moduleController)" class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('controllers') ? 'text-white bg-primary transition-all ' : 'text-primary']">
                  <NuxtLink to="/controllers"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">

                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                        class="w-6 h-6 flex-shrink-0">
                        <path fill-rule="evenodd"
                           d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                           clip-rule="evenodd" />
                     </svg>

                     <span class="uppercase font-semibold">{{ $t('controllers') }}</span>
                  </NuxtLink>
               </div>


            </li>
            

            <li v-if="((RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN || RoleIndex(UserProfile()?.roles) === RoleCategory.AGENCY_MANAGER) && $config.public.moduleMateriel)"
               class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('stock') ? 'text-white bg-primary transition-all ' : 'text-primary']">
                  <NuxtLink to="/stock" @click="markNewArticleAsViewed"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                        class="size-6 flex-shrink-0">
                        <path
                           d="M6 3a3 3 0 0 0-3 3v1.5a.75.75 0 0 0 1.5 0V6A1.5 1.5 0 0 1 6 4.5h1.5a.75.75 0 0 0 0-1.5H6ZM16.5 3a.75.75 0 0 0 0 1.5H18A1.5 1.5 0 0 1 19.5 6v1.5a.75.75 0 0 0 1.5 0V6a3 3 0 0 0-3-3h-1.5ZM12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5ZM4.5 16.5a.75.75 0 0 0-1.5 0V18a3 3 0 0 0 3 3h1.5a.75.75 0 0 0 0-1.5H6A1.5 1.5 0 0 1 4.5 18v-1.5ZM21 16.5a.75.75 0 0 0-1.5 0V18a1.5 1.5 0 0 1-1.5 1.5h-1.5a.75.75 0 0 0 0 1.5H18a3 3 0 0 0 3-3v-1.5Z" />
                     </svg>

                     <span class="uppercase font-semibold">{{ $t('materialManagement') }}</span>
                     <div v-if="isNewArticle" class="ml-auto px-2 bg-red-500 text-white rounded">{{ $t('new') }}</div>

                  </NuxtLink>
               </div>


            </li>

            <li v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.CONTROLLER" class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('controller_reports_x') ? 'text-white bg-primary transition-all ' : 'text-primary']">
                  <NuxtLink to="/controller_reports_x"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                        class="w-6 h-6 flex-shrink-0">
                        <path fill-rule="evenodd"
                           d="M1.5 5.625c0-1.036.84-1.875 1.875-1.875h17.25c1.035 0 1.875.84 1.875 1.875v12.75c0 1.035-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 18.375V5.625ZM21 9.375A.375.375 0 0 0 20.625 9h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5Zm0 3.75a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5a.375.375 0 0 0 .375-.375v-1.5ZM10.875 18.75a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h7.5ZM3.375 15h7.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375h-7.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375Zm0-3.75h7.5a.375.375 0 0 0 .375-.375v-1.5A.375.375 0 0 0 10.875 9h-7.5A.375.375 0 0 0 3 9.375v1.5c0 .207.168.375.375.375Z"
                           clip-rule="evenodd" />
                     </svg>

                     <span class="uppercase font-semibold">{{ $t('reports') }}</span>
                  </NuxtLink>
               </div>
            </li>
            
            <li v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN" class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('marking_operator') ? 'text-white bg-primary transition-all ' : 'text-primary']">
                  <NuxtLink to="/marking_operator"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                           d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                     </svg>


                     <span class="uppercase font-semibold">{{ $t('markingOperator') }}</span>
                  </NuxtLink>
               </div>


            </li>
            <li v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN" class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('static_upload') ? 'text-white bg-primary transition-all ' : 'text-primary']">
                  <NuxtLink to="/static_upload"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                        class="size-6 flex-shrink-0">
                        <path fill-rule="evenodd"
                           d="M11.622 1.602a.75.75 0 0 1 .756 0l2.25 1.313a.75.75 0 0 1-.756 1.295L12 3.118 10.128 4.21a.75.75 0 1 1-.756-1.295l2.25-1.313ZM5.898 5.81a.75.75 0 0 1-.27 1.025l-1.14.665 1.14.665a.75.75 0 1 1-.756 1.295L3.75 8.806v.944a.75.75 0 0 1-1.5 0V7.5a.75.75 0 0 1 .372-.648l2.25-1.312a.75.75 0 0 1 1.026.27Zm12.204 0a.75.75 0 0 1 1.026-.27l2.25 1.312a.75.75 0 0 1 .372.648v2.25a.75.75 0 0 1-1.5 0v-.944l-1.122.654a.75.75 0 1 1-.756-1.295l1.14-.665-1.14-.665a.75.75 0 0 1-.27-1.025Zm-9 5.25a.75.75 0 0 1 1.026-.27L12 11.882l1.872-1.092a.75.75 0 1 1 .756 1.295l-1.878 1.096V15a.75.75 0 0 1-1.5 0v-1.82l-1.878-1.095a.75.75 0 0 1-.27-1.025ZM3 13.5a.75.75 0 0 1 .75.75v1.82l1.878 1.095a.75.75 0 1 1-.756 1.295l-2.25-1.312a.75.75 0 0 1-.372-.648v-2.25A.75.75 0 0 1 3 13.5Zm18 0a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.372.648l-2.25 1.312a.75.75 0 1 1-.756-1.295l1.878-1.096V14.25a.75.75 0 0 1 .75-.75Zm-9 5.25a.75.75 0 0 1 .75.75v.944l1.122-.654a.75.75 0 1 1 .756 1.295l-2.25 1.313a.75.75 0 0 1-.756 0l-2.25-1.313a.75.75 0 1 1 .756-1.295l1.122.654V19.5a.75.75 0 0 1 .75-.75Z"
                           clip-rule="evenodd" />
                     </svg>
                     <span class="uppercase font-semibold">{{ $t('uploadStaticData') }}</span>
                  </NuxtLink>
               </div>


            </li>

            <li v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN" class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('configuration') ? 'text-white bg-primary transition-all ' : 'text-primary']">
                  <NuxtLink to="/configuration"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                           d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.1 2.016c.293.536.764.857 1.32.857h.03c.676 0 1.222-.59 1.222-1.316V4.82c0-.597-.237-1.17-.659-1.591l-1.494-1.494c-.196-.196-.512-.312-.824-.312h-2.79c-.262 0-.525.05-.785.147L12 3.554l-1.652-.98c-.26-.097-.523-.147-.785-.147H6.773c-.312 0-.628.116-.824.312L4.455 3.716c-.422.421-.659.994-.659 1.591v2.79c0 .597.237 1.17.659 1.591l1.494 1.494c.196.196.512.312.824.312h2.79c.262 0 .525-.05.785-.147L12 7.028l1.652.98c.26.097.523.147.785.147h2.79c.312 0 .628-.116.824-.312l1.494-1.494c.422-.421.659-.994.659-1.591v-.03c0-.676-.546-1.222-1.222-1.222h-.03c-.556 0-1.027-.321-1.32-.857l-1.1-2.016a1.125 1.125 0 00-1.37-.49l-1.217.456c-.355.133-.75.072-1.075-.124a6.216 6.216 0 00-.22-.127c-.332-.184-.582-.496-.645-.87L9.594 3.94z" />
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path stroke-linecap="round" stroke-linejoin="round"
                           d="M12 15v6m-3-6h6m-6 0v6m3-6v6" />
                     </svg>


                     <span class="uppercase font-semibold">{{ $t('settings') }}</span>
                  </NuxtLink>
               </div>


            </li>

            <li v-if="RoleIndex(UserProfile()?.roles) === RoleCategory.ADMIN" class="flex items-center flex-col">


               <div class="flex py-1 w-full rounded hover:bg-primary-50 hover:text-primary-600"
                  :class="[($router.currentRoute.value.name as string)?.startsWith('contact') ? 'text-white bg-primary transition-all ' : 'text-primary']">
                  <NuxtLink to="/contact"
                     class="flex items-center gap-2 pl-2 font-normal text-[10px] px-10 text-start justify-start w-full cursor-pointer">
                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                           d="M21.75 9v.906a2.25 2.25 0 0 1-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 0 0 1.183 1.981l6.478 3.488m8.839 2.51-4.66-2.51m0 0-1.023-.55a2.25 2.25 0 0 0-2.134 0l-1.022.55m0 0-4.661 2.51m16.5 1.615a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V8.844a2.25 2.25 0 0 1 1.183-1.981l7.5-4.039a2.25 2.25 0 0 1 2.134 0l7.5 4.039a2.25 2.25 0 0 1 1.183 1.98V19.5Z" />
                     </svg>


                     <span class="uppercase font-semibold">{{ $t('contact') }}</span>
                  </NuxtLink>
               </div>


            </li>
         </ul>
      </div>
   </aside>
</template>

<script lang="ts">
import { CheckNewArticleStatus, MarkNewArticleAsViewed } from '~/composables/agency/agency';

export default defineComponent({
    name: "SideBar",
    data() {
       return {
          unreadReport: 0 as number,
          t: useI18n().t,
          isNewMaterial: true,
          isNewArticle: false,
       };
    },
    mounted() {
       this.$nextTick(() => {
          this.getReportCount();
          this.getNewArticleStatus();
       });
    },
    methods: {
       async getReportCount(): Promise<void> {
          try {
             const userId = UserProfile()?.uid;
             if (userId) {
                const res = await GetUnreadReport(userId);
                this.unreadReport = res;
             }
          } catch (err) {
             ErrorAlert(err);
          }
       },
       async getNewArticleStatus(): Promise<void> {
          try {
             const agencyId = UserProfile()?.agencyId;
             if (agencyId && RoleIndex(UserProfile()?.roles) === RoleCategory.AGENCY_MANAGER) {
                const res = await CheckNewArticleStatus(agencyId);
                this.isNewArticle = res.isNewArticle;
             }
          } catch (err) {
             console.error(err);
          }
       },
       async markNewArticleAsViewed(): Promise<void> {
          try {
             const agencyId = UserProfile()?.agencyId;
             if (agencyId && RoleIndex(UserProfile()?.roles) === RoleCategory.AGENCY_MANAGER) {
                await MarkNewArticleAsViewed(agencyId);
                this.isNewArticle = false;
             }
          } catch (err) {
             console.error(err);
          }
       },
    },
});
</script>

<style scoped>
*::-webkit-scrollbar {
   width: 2px;
}
</style>
